<template>


  <div class="">
    <div allowFullScreen="true" ref="image_box" id="image_box" class="">
      <div v-if="mode == 0">
        <div id="mySidenav" class="sidenav" style="width:320px;margin-left: -320px;">
          <a class="closebtn" v-on:click="hideShow2" style="cursor: pointer">×</a>
          <a v-on:click="downloadSlidesProxy(qui), understandStatus(qui)" style="cursor: pointer">Download <span class="status">{{stringStatus}}</span></a>
          <a v-on:click="openFullscreen($refs.image_box)" style="cursor: pointer">Open Full Screen </a>
          <a v-on:click="closeFullscreen" style="cursor: pointer">Close Full Screen</a>
          <router-link to="/config">
            Configuration Page
          </router-link>
          <a id="configurationErrorMessage" class="version" style="color: red;font-style: italic;bottom: 80px;padding: 16px 8px 16px 0px; display:none"> Configuration Error </a>
          <a id="internetErrorMessage" class="version" style="color: red;font-style: italic;bottom: 160px;padding: 16px 8px 16px 0px; display:none"> Connection Error </a>
          <p class="version" id="version"></p>


        </div>
      </div>
      <div ref="animation" id="animation"></div>
      <!--      <div class="text-center">-->
      <img :src="image1" divImage id="divImage" ref="divImage"/>

      <!--      <video id="videoMp4" autoplay :key="videoMp4">-->
      <!--        <source :src="videoMp4" type="video/mp4">-->
      <!--      </video>-->

      <video id="player" autoplay="autoplay">

      </video>


      <div v-if="mode == 0">
        <div id="loading" class="mx-auto" style="position: absolute">
          <img src="../assets/loading.svg">
          <p class="mt-3">Download in progress. Please wait..</p>
          <p id="progress" class="mt-3"></p>
        </div>
      </div>
      <div v-if="mode == 1">
        <div id="loading" align="center" style="margin-left:auto;margin-right:auto; border:0px solid #000000;font-family:Arial, Helvetica, sans-serif;padding:3px;margin-top:60px;">
          <div style="color:#FF6600; font-weight: bold">{{messaggioAttesa}}<br>{{messaggioAttesa2}}</div><br>
          <img src="../assets/ajax-loader.gif" width="66" height="66" style="margin-top:10px;"></div>
      </div>
      <div v-if="mode == 0">
        <button id="hideButton" v-on:click="hideShow2()" class="py-2" style="display: block; position:absolute; bottom: 0; right: 0; background: transparent; border: none;font-size:0;height: 100px;width: 100px; z-index: 1"></button>
      </div>
    </div>

  </div>
</template>
<style>

 #divImage {
    /* Absolute centering */
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    /* Size limit */
    max-width: 100%;
    max-height: 100%;
    /* Other required settings */
    margin: auto;
    overflow: auto;
  }

 #animation {
    /* Absolute centering */
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    /* Size limit */
    max-width: 100%;
    max-height: 100%;
    /* Other required settings */
    margin: auto;
    overflow: auto;
  }

  #player {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    min-width: 100%;
    min-height: 100%;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
    overflow: auto;
  }



</style>


<script>
  import lottie from '../lottie.js';
  import { skipElement} from "../main";
  //import * as animationData from  '../assets/t.json'
import axios from "axios";

  import router from '../router';
  import {showSlide, openFullscreen, closeFullscreen, hideShow2, understandStatus, saveJson, autofit} from '../utility';
  import {
    readSlides,
    checkUpdate,
    downloadSlides,
    downloadSlidesProxy,
    fetchSingleElement,
    fetchSingleElementLocal,
    notifyPhfUpdate
  } from '../apis';
  import {Player} from "../videoFunction";


  export default {
    name: "ChannelSlides",

    data() {
      var qui = this;
      var apiUrl = "";
      var apiToken = "";
      var idUser = "";
      var nomeUser = "";
      var tipoApp = 0;
      var userId = 0;
      var palinsesto = "";
      var videoTerminal = "";
      var videoVersion = "";
      var mode = 0;
      var appUrl = "";
      var lingua = "";
      var messaggioAttesa = "Loading preview";
      var messaggioAttesa2 = "please wait";
      var debug = 0;
      var idUnique = 0;

      //variabile che serve per il messaggio delle animate vecchie dato che non fa mai l'onload se non la prima volta
      var firsTimeSlideAnimataOld = -1;
      //per prendere i parametri dalla query
      let parameter = this.$router.currentRoute.query;
      if(parameter.modalita != null){
        mode = parameter.modalita;
      }
      if(debug == 1) {
        console.log("modalita: " + mode);
      }
      nomeUser = parameter.nomeUser;
      userId = parameter.userId;
      tipoApp = parameter.tipoApp;
      palinsesto = parameter.palinsesto;
      lingua = parameter.lingua;
      if(parameter.debug != null){
        debug = parameter.debug;
      }
      if(parameter.id != null){
        idUnique = parameter.id;
      }
      var js = JSON.parse(window.localStorage.getItem("jso"));
      if(debug == 1) {
        console.log("json di configurazione: " + js);
      }

      appUrl = parameter.url;
      //selezione lingua
      if(lingua == "IT"){
        messaggioAttesa = "E' in corso il caricamento della preview";
        messaggioAttesa2 = "la preghiamo di attendere";
      }else if(lingua == "EN"){
        messaggioAttesa = "Loading preview";
        messaggioAttesa2 = "please wait";
      }else if(lingua == "ES"){
        messaggioAttesa = "Cargando vista previa";
          messaggioAttesa2 = "por favor espere";
      }else if(lingua == "FR"){
        messaggioAttesa = "Chargement d'un aperçu en cours";
        messaggioAttesa2 = "attendez s'il vous plait";
      }else if(lingua == "PT"){
        messaggioAttesa = "Carregando visualização";
        messaggioAttesa2 = "por favor aguarde";
      }else if(lingua == "DE") {
        messaggioAttesa = "Die Vorschau wird gerade geladen";
        messaggioAttesa2 = "bitte warten";
      }

      if ((js == null || Object.keys(js).length < 1) && mode == 0) {
        // alert("There is no setup data. Please configure you player before.");
        router.push("config");
        return;
      }else if(mode == 0 && js != null){
        apiUrl = js.apiUrlj;
        apiToken = js.apiTokenj;
        idUser = js.idUserj;
        videoTerminal = js.videoTerminalj;
        videoVersion = js.videoVersionj;
      }

      return {
        qui,
        slides: null,
        slidesTest: null,
        status: -1, //-1: not init; 0: nothing to do here; 1: download pending; 2: in download
        stringStatus: null,
        updateAvailableDesc: "",
        updaterThread: null,
        checkThread: null,
        notifyThread: null,
        image1: "",
        // videoMp4: "",
        web_worker: null,
        dataDownload : "19910912",
        jsonOld:"",
        mode: mode, //default mode player video: 0, 1: modalità preview
        tipoApp: tipoApp, //0: phfIt, 1:phfes, 2: fuclrishop, 3: qas, 4: dev
        userId: userId,
        nomeUser: nomeUser,
        palinsesto: palinsesto,
        appUrl: appUrl,
        lingua: lingua,
        messaggioAttesa: messaggioAttesa,
        messaggioAttesa2: messaggioAttesa2,
        debug: debug,
        idUnique: idUnique,
        firsTimeSlideAnimataOld:firsTimeSlideAnimataOld,
        API_URL: apiUrl,
        API_TOKEN: apiToken,
        ID_USER: idUser,
        VIDEO_TERMINAL: videoTerminal,
        VIDEO_VERSION: videoVersion,
      };
    },


    created() {

      this.checkSlides();
    },



    mounted() {
      Player.init("player", this.qui);
      //per prendere i parametri da querystring

    },

    methods: {
      openFullscreen,
      closeFullscreen,
      hideShow2,
      understandStatus,

      resetStatusOnError(){
        if(this.debug == 1) {
          console.log("Errore nello scaricamento dei contenuti");
        }
        this.status = 0;
        this.startCheckUpdateInterval();
        if(this.jsonOld != null && this.jsonOld.length > 0){
          saveJson(this.jsonOld);
        }
      },

    startAnimation(url) {
      var animation;
    if(animation){
      animation.destroy();
    }
    var container = this.$refs.animation;
    console.log(url)
    var options = {
    method: 'GET',
    url: url,
    responseEncoding: 'utf8',
    responseType: 'json'
  }

    axios(options)
    .then(function (response) {
      var json = response.data;
      //json = atob(response.data);
      //json =decodeURIComponent(escape(json));
      //json = JSON.parse(json)

      animation = lottie.loadAnimation({
      animationData: json,
      container: container,
      renderer: 'svg',
      autoplay: false,
      loop : false

        })

      autofit(animation.renderer.elements);
      animation.addEventListener('complete', function(){
        animation.destroy();
        animation = null;
        skipElement( Player.phfcli);
      })

     animation.play();
    })

    .catch(function (error) {
      console.log(error)
    });




      },




      checkStatus() {
        let phfcli = this;
        understandStatus(phfcli);
        if (this.status == 0) {
          //console.log("nothing to do! System is up to date");
        } else if (this.status == 1) {
          //blocchiamo handshake
          clearInterval(this.checkThread);
          var adesso = new Date();
          this.dataDownload = adesso.getTime() + "_";
          //salvo il vecchio json per poterlo ripristinare in caso di errore
          this.jsonOld = JSON.parse(window.localStorage.getItem("jsonSlides"));
          if(this.debug == 1) {
            console.log("download pending. call the api to content download");
          }
          //modalita default
          if(this.mode == 0){
            //Scarico phfvideo.xml e crea json
            this.downloadSlides(phfcli);
          }else if(this.mode == 1){
            this.readSlides(phfcli);
          }
        } else if (this.status == 2) {
          //download xml in progress
          if(this.debug == 1) {
            console.log("Download XML in progress. Please wait...");
          }
        } else if (this.status == 3) {
          //File xml scaricato correttamente, inizio scaricamento slides
          for (const slide of this.slides) {
            if(this.mode == 0){
              this.fetchSingleElement(slide, phfcli);
            }else if(this.mode == 1){
              this.fetchSingleElementLocal(slide, phfcli);
            }
          }
          this.status = 4;
        } else if (this.status == 4) {
          //notifico l'update solo se è player video
          if(this.mode == 0){
            //		mando a phf il feedback di avvenuto aggiornamento
            this.notifyPhfUpdate();
          }
          this.playerExec();
          // filesystem.deleteAllDownloads();
          this.status = 0;
          if(this.mode == 0) {
            this.startCheckUpdateInterval();
          }
        } else {
          if(this.debug == 1) {
            console.log(
              "Hey, what's this status? I can't recognize it! [" + this.status + "]");
          }
        }
      },
      startInterval() {
        if (this.mode == 0){
          this.startCheckUpdateInterval();
          this.updaterThread = setInterval(this.checkStatus, 5000);
          // this.uploadInfoThread = setInterval(this.uploadInfo, 6000000);
        }else if(this.mode == 1){
          this.updaterThread = setInterval(this.checkStatus, 5000);
        }
      },
      startCheckUpdateInterval(){
        this.checkThread = setInterval(this.checkUpdate, 30000);
      },


      checkUpdate,
      downloadSlides,
      downloadSlidesProxy,
      fetchSingleElement,
      notifyPhfUpdate,
      showSlide,
      readSlides,
      fetchSingleElementLocal,
      //primo metodo eseguito all'apertura dell'app, se modalità preview, resetta il jsonslides e mette stato a 1, altrimenti inizia la riproduzione contenuti
      checkSlides() {
        window.newsSlideIndex = 0;
        this.startBackgroundProcessInternal();
        if(this.debug == 1) {
          console.log("checkSlide: startato backgroundProcess");
        }

        if(this.mode == 1){
          saveJson("");
        }

        var slidesArray = JSON.parse(window.localStorage.getItem("jsonSlides"));
        if (slidesArray != null && slidesArray != "") {
          this.slides = slidesArray;
          this.playerExec();
        } else {
          this.image1 = "";
          if(this.mode == 0) {
            this.checkUpdate(true);
          }else{
            this.status = 1;
          }
        }
        if(this.debug == 1) {
          console.log("finito checkSlide")
        }
        // this.checkUpdate();
        this.startInterval();
      },


      async playerExec() {
        this.web_worker.postMessage([
          "resetElems"
        ]);
        if(this.debug == 1) {
          console.log("checkSlide: resettato elementi web worker");
        }
        for (const slide of this.slides) {
          if(this.debug == 1) {
            console.log("checkSlide: entrato nel for");
            // if (slide.media != null) {
            console.log("checkSlide: passato l'if");
          }
          this.web_worker.postMessage([
            "pushElem",
            JSON.parse(JSON.stringify(slide)),
            //passo anche il valore tel time preso dal file:
            slide.jsonObj.time
          ]);
          if(this.debug == 1) {
            console.log("checkSlide: pushato " + JSON.stringify(slide));
          }
          // }
        }
      },
//starta il service worker e inizia a comunicare
      startBackgroundProcessInternal() {
        if(this.debug == 1) {
          console.log("startBackgroundProcess");
        }
        if (typeof Worker !== "undefined") {
          if (typeof this.web_worker == "undefined" || this.web_worker == null) {
            this.web_worker = new Worker("background-process.js");
          }
          let phfcli = this;
          this.web_worker.onmessage = function (event) {
            //updateTimer(event.data);
            if (event.data[0] === "slide_change") {
              // console.log("--------");
              if(this.debug == 1) {
                console.log("cambio slide web_worker ");
                console.log("nel background process " + event.data[1].jsonObj.href);
              }

              var loading = document.getElementById("loading");
              if (loading != null) {
                loading.style.display = "none";
              }

              let slideUrl = event.data[1].jsonObj.href;
              if (event.data[1].jsonObj.url && event.data[1].jsonObj.url.includes('foto/news')) {
                let files = event.data[1].jsonObj.folderFiles.split("|");
                if(window.newsSlideIndex >= files.length) {
                  window.newsSlideIndex = 0;
                }
                slideUrl += "/" + files[window.newsSlideIndex];
                window.newsSlideIndex++;
              }
              //passo al metodo anche il type della slide
              if(event.data[1].jsonObj.lottie > 0){
                phfcli.showSlide(slideUrl, true, phfcli, "animation", event.data[2]);
              }else if(event.data[1].jsonObj.animataOld>0){
                //slide animata vecchia, quindi immagina fissa che mostra messaggio che in preview non è abilitata
                phfcli.showSlide(slideUrl, true, phfcli, "animataOld", event.data[2]);
              }
              else{
               phfcli.showSlide(slideUrl, true, phfcli, event.data[1].jsonObj.typej, event.data[2]);
              }
            } else {
              if(this.debug == 1) {
                console.log("web_worker evento ignorato dal main [" + event.data[0] + "]");
              }
            }
          };
          if(this.debug == 1) {
            console.log("chiamo web_worker.postMessage ");
          }
          this.web_worker.postMessage(["state_change", true]);
        } else {
          window.alert("Browser not supported..");
        }
      },
    }
  };

 const swPath = "./sw.js";
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", function () {
      navigator.serviceWorker.register(swPath).then(
        function (registration) {
          // Registration was successful
          console.log("ServiceWorker registration successful with scope: ", registration.scope);
        },
        function (err) {
          // registration failed :(
          console.log("ServiceWorker registration failed: ", err);
        }
      );
    });
  } else {
    // console.log("no ServiceWorker in navigator ");
  }

</script>

